export interface AIInterpretationFilterModel {
  status: string[]
  roles: string[]
  joinDate: string | null
  loginDate: string | null
}

export const EMPTY_AI_INTERPRETATION_FILTER: AIInterpretationFilterModel = {
  status: [],
  roles: [],
  joinDate: null,
  loginDate: null,
}

export interface RequestorRow {
  userId: string
  firstName: string
  lastName: string
  email: string
  avatar?: string | null
  pinCodeString?: string | null
  role: string
  customerName: string
  accountStatus: string
  isConfirmed: boolean
  aiInterpretationPermission: boolean
}

export interface PaginationInfo {
  page: number
  from: number
  to: number
  total: number
  last_page: number
  items_per_page: number
}

export interface FilterQueryParams {
  page: number
  items_per_page: number
  search: string
  sort: string | null
  order: string
}
